<template>
  <g>
    <!-- Corner ornament stars -->
    <svg v-for="ornament in ornaments" :key="ornament.key"
      :x="ornament.x" :y="ornament.y"
      :width="ornamentWidth" :height="ornamentHeight"
      viewBox="0 0 48.83 90"
      xmlns="http://www.w3.org/2000/svg">
      <g>
        <circle cx="1.06" cy="19.26" r="1.06"/>
        <g>
          <path d="M26.39,37.69c.08.06.22-.21.27-.29,2.83-4.51,5.03-9.99,7.23-15.09.1-.23.55-.62.74-.37.45.58-.23,1.69-.47,2.37-1.56,4.38-3.85,8.81-5.75,13.09-.24.55-.83,2.01-1.11,2.39-1.24,1.61-1.83-1.67-2.78-3.1-.08-.12-.21.03-.26.18-.15.46-.36,1.2-.56,1.69-.25.66-1.33,2.33-2.12,1.38-2.26-5.41-5.12-10.8-7.03-16.34-.17-.5-.86-1.54-.34-1.66.93-.21,1.41,1.55,1.79,2.43,1.97,4.59,2.98,7.94,6.05,12.98.05.09.34.22.34.22.35-1.04.7-2.11.86-3.2.76-5,.5-11,.52-16.11,0-2.53-.19-5.41-.01-7.88.06-.77.52-2.19,1.08-1.19.39.7.16,6.05.17,9.07.02,5.11-.24,11.1.52,16.11.17,1.13.56,2.23.86,3.33Z"/>
          <path d="M24.26,52.19c.42.28.61-.68.67-.99.16-.83.27-2.66.66-3.37s.99-.99,1.49-.27c2.27,3.24,3.64,7.13,5.18,10.82.33.79.89,2.15.63,2.5s-.79-.48-.98-.77c-1.96-2.99-3.18-6.74-5.12-9.75-.08-.12-.24-.24-.28-.16-.38.81-1.16,3.51-1.26,5.31-.42,7.9-.16,15.09-.38,22.62-.03,1.12.11,2.42.01,3.51-.02.16,0,.33-.19.4,0,0-.71.08-.82-.09-.25-.39.04-2.63,0-3.94-.09-3.81-.17-7.6-.24-11.4-.08-4.44.3-9.54-.67-13.81-.2-.87-.59-2.44-.72-2.59-.2-.22-.26-.02-.33.1-1.9,2.96-3.07,6.68-4.99,9.64-.15.23-.81,1.05-1.06.83-.22-.2.53-2.21.71-2.65,1.5-3.53,3.24-6.7,5.03-10.48.2-.41.74-.58,1.18-.29.71.46.68,4.35,1.45,4.86Z"/>
          <path d="M40.26,33.57c.33.34-1.06,1.4-1.31,1.62-2.74,2.3-5.9,4.2-8.75,6.42-.1.08-.36.23-.16.45.26.3.67.36,1.04.51,1.99.8,5.34,1.11,7.5,1.25.85.05,2.11-.14,2.87,0,.17.03.29.1.38.24.23.44-.27.59-.63.63-3.33.38-7.06.25-10.47.4-.23.01-.82-.08-.84.41-.02.72,2.68,1.67,4.04,2.46,2.18,1.27,4.86,2.45,6.9,3.85.72.5,1.64,1.56.08,1.17-1.91-.48-5.98-3.12-7.98-4.15-1.01-.52-3.91-1.63-4.55-2.32s-.24-1.78.54-2.22c.21-.12,1.55-.48,1.21-.72-4.21-3.05-.87-3.08,1.29-4.52,2.19-1.46,4.33-3.06,6.6-4.4.32-.19,2.01-1.31,2.24-1.07Z"/>
          <path d="M20.72,41.24c1.22.99-1.57,1.6-2.08,2.33-.31.44.79.48,1.21.72.78.43,1.18,1.56.54,2.22-.68.71-3.52,1.79-4.55,2.32-2.33,1.2-4.81,2.79-7.18,3.82-.45.2-1.14.59-1.59.29-.28-.39.69-1.01.95-1.18,2.04-1.38,4.65-2.54,6.82-3.8,1.36-.79,4.05-2.05,4.04-2.46,0-.23-.6-.32-.82-.4-3.24-1.08-7.17-.03-10.5-.41-.37-.04-.95-.33-.67-.74.16-.25,2.78-.11,3.3-.14,2.24-.14,5.35-.51,7.49-1.24.39-.13.93-.25,1.11-.46.15-.17-.11-.3-.25-.41-2.84-2.18-6.01-4.24-8.73-6.52-.48-.41-1.62-1.06-1.31-1.62.27-.5,2.83,1.44,3.24,1.7,3.04,1.9,6.18,3.72,8.97,5.97Z"/>
          <path d="M20.69,39.77c.15.17.73.62.69.84-.07.43-.57.32-.86.12-.92-.64-2.77-3.19-3.7-4.17-1.84-1.94-3.87-3.72-5.63-5.75-.28-.32-.9-.9-.44-1.2.15-.1.23-.06.38,0,.16.07,1.28,1.26,1.5,1.5,2.62,2.81,5.54,5.78,8.04,8.64Z"/>
          <path d="M33.68,34.74c-1.83,1.92-3.57,3.93-5.34,5.91-.28.22-.56.46-.84.11-.23-.25.05-.5.2-.7.73-.95,2.23-2.1,3.11-3.01,1.82-1.89,3.48-3.95,5.27-5.86.33-.35,1.17-1.29,1.5-1.5.7-.46.63.32.24.87-1.02,1.46-2.9,2.88-4.13,4.18Z"/>
          <path d="M31.84,51.7c.14-.04.29-.02.42.05l6.31,7.56c.07,1.31-.64.53-1.13,0-1.96-2.14-3.65-4.73-5.62-6.88-.18-.19-.33-.63,0-.73Z"/>
          <path d="M16.6,51.71c.46-.13.67.2.47.6l-6.37,7.63c-.36.31-.72-.29-.5-.63l6.4-7.61Z"/>
          <path d="M46.39,20.82c.32.33-1.02,1.69-1.31,2-1.82,2-3.87,3.81-5.56,5.94-.33.33-.8.25-.73-.24.06-.41,2.55-2.68,3.03-3.2.98-1.05,2.92-3.64,3.93-4.32.22-.15.33-.24.63-.18Z"/>
          <path d="M9.88,28.93c-.13.09-.51-.02-.63-.17-1.68-2.18-3.77-3.99-5.62-6.01-.29-.32-1.57-1.6-1.24-1.94.3-.06.41.03.63.18.98.66,2.85,3.18,3.8,4.2.5.53,3.1,2.91,3.16,3.33.01.07-.08.39-.1.41Z"/>
          <path d="M46.12,68.22c.31-.33-.98-1.65-1.25-1.96-1.74-1.96-3.69-3.74-5.31-5.83-.32-.33-.76-.24-.69.23.06.4,2.43,2.63,2.9,3.14.94,1.03,2.78,3.57,3.75,4.24.21.15.32.23.6.18Z"/>
          <path d="M9.88,60.2c-.12-.09-.49.02-.6.17-1.62,2.14-3.62,3.92-5.4,5.91-.28.31-1.51,1.58-1.2,1.91.29.05.39-.03.61-.18.94-.65,2.74-3.12,3.65-4.12.48-.52,2.98-2.87,3.03-3.27.01-.07-.07-.38-.1-.4Z"/>
          <path d="M27.66,46.71c.19-.12.67,0,.8.23l3.01,3.87c.06.22-.3.41-.51.39-.35-.04-2.84-3.43-3.38-3.89-.1-.12.02-.56.08-.6Z"/>
          <path d="M21.11,46.72c.05.06.11.33.1.41-.02.19-2.07,2.71-2.38,3.06-.21.24-1.58,1.72-1.44.57.02-.15,1.51-2.08,1.76-2.38.29-.35,1.37-1.74,1.68-1.77.09.02.23.04.29.11Z"/>
          <path d="M20.78,43.83h0,0c1.76.47,3.13,1.85,3.6,3.6h0s0,0,0,0c.47-1.76,1.85-3.13,3.6-3.6h0,0c-1.76-.47-3.13-1.85-3.6-3.6h0s0,0,0,0c-.47,1.76-1.85,3.13-3.6,3.6Z"/>
        </g>
        <circle cx="24.49" cy="1.06" r="1.06"/>
        <circle cx="24.49" cy="4.39" r="1.06"/>
        <circle cx="24.49" cy="85.61" r="1.06"/>
        <circle cx="24.49" cy="88.94" r="1.06"/>
        <circle cx="47.77" cy="19.26" r="1.06"/>
        <circle cx="1.06" cy="69.73" r="1.06"/>
        <circle cx="47.77" cy="69.73" r="1.06"/>
        <circle cx="44.52" cy="44.17" r="1.06"/>
        <circle cx="4.27" cy="44.17" r="1.06"/>
      </g>
    </svg>
  </g>
</template>

<script>
// Rendered width of each ornament (in inches)
const ORNAMENT_WIDTH = 0.6875;
// Rendered height of each ornament (in inches)
const ORNAMENT_HEIGHT = 1.25;
// Distance from the left/right edge of the opening to the nearest edge of the ornament (in inches)
const HORIZONTAL_OFFSET = 0.3125;
// Distance from the top/bottom edge of the opening to the nearest edge of the ornament (in inches)
const VERTICAL_OFFSET = 0;

export default {
  props: {
    artworkOpenings: {
      type: Array,
      required: true
    }
  },
  computed: {
    ornamentWidth() {
      return ORNAMENT_WIDTH;
    },
    ornamentHeight() {
      return ORNAMENT_HEIGHT;
    },
    ornaments() {
      return this.artworkOpenings.flatMap((opening) => {
        const left = opening.x;
        const top = opening.y;
        const right = opening.x + opening.width;
        const bottom = opening.y + opening.height;

        return [
          { key: `${opening.key}-ornament-tl`, x: left - HORIZONTAL_OFFSET - ORNAMENT_WIDTH, y: top - VERTICAL_OFFSET - ORNAMENT_HEIGHT },
          { key: `${opening.key}-ornament-tr`, x: right + HORIZONTAL_OFFSET, y: top - VERTICAL_OFFSET - ORNAMENT_HEIGHT },
          { key: `${opening.key}-ornament-br`, x: right + HORIZONTAL_OFFSET, y: bottom + VERTICAL_OFFSET },
          { key: `${opening.key}-ornament-bl`, x: left - HORIZONTAL_OFFSET - ORNAMENT_WIDTH, y: bottom + VERTICAL_OFFSET },
        ];
      });
    }
  }
};
</script>
